import { VStack, Grid, Heading } from "@chakra-ui/react";
import ItemBox from "../ItemBox/ItemBox";
import BarChart from "./BarChart";
import FitmentInterpretation from "./FitmentInterpretation";
import MatchJobProfileGrid from "./MatchJobProfileGrid";
import PieChart from "./PieChart";
import { useLocation } from "react-router-dom";
import UnRankedPools from "./UnRankedPools";

const MatchJobProfileResult = () => {
  const { state } = useLocation();
  const {
    rowData,
    scoreCount,
    skillsCount,
    totalCandidates,
    maxMatchedSkills,
    selectedJobProfile,
    selectedResumePools,
    unRankedPools
  } = state;
  return (
    <VStack>
      <Heading>Match a job profile with existing pools</Heading>
      <br />
      <Grid templateColumns="repeat(2, 1fr)" gap={3}>
        <ItemBox label="Job Profile" value={selectedJobProfile.PK} />
        <ItemBox label="Pools Processed" value={selectedResumePools.map(item => item.value).join(', ')} />
        <ItemBox label="Total Candidates" value={totalCandidates} />
        <ItemBox label="Max Matched Skills" value={maxMatchedSkills} />
      </Grid>

      <br />
      <Grid templateColumns="repeat(3, 1fr)" gap={3}>
        <FitmentInterpretation />
        <BarChart skillsCount={skillsCount} />
        <PieChart scoreCount={scoreCount} />
      </Grid>
      <br />
      <MatchJobProfileGrid rowData={rowData} />
      {/* <UnRankedPools unRankedPools={unRankedPools} selectedJobProfile={selectedJobProfile} /> */}
    </VStack>
  );
};

export default MatchJobProfileResult;
